import React from "react";

import Logo_Constructora from "../../assets/logo-constructora-white.svg";
import Logo_Proyecto from "../../assets/logo_proyecto-white.svg";

import Icon_Ajustes from "../../assets/icons/icon_ajutes.svg"; 
import Icon_Interaccion from "../../assets/icons/icon_interaccion.svg"; 
import Icon_Cotiza from "../../assets/icons/icon_Cotiza.svg"; 
import Icon_Mouse3 from "../../assets/icons/icon_mouse3.svg"; 
import Icon_Mouse2 from "../../assets/icons/icon_mouse2.svg"; 
import Icon_Mouse1 from "../../assets/icons/icon_mouse1.svg"; 


interface Props {
  isPortrait: boolean,
  showIntro: boolean,
  tourLoaded: boolean,
  productsUpdated: boolean,
  setShowIntro: (value: boolean) => void;
}

const Intro: React.FC<Props> = ({ isPortrait, showIntro, tourLoaded, productsUpdated, setShowIntro}) => {
  
  return (
    <div className={`tour-full-intro ${showIntro === true ? '':'hide'} ${isPortrait === true ? 'portrait':''}`}>
      <div className={`tour-intro-container ${isPortrait ? 'portrait':''}`}>
        <div className={`tour-intro ${isPortrait ? 'portrait':''}`}>

          <div className={`tour-intro-container-logos ${isPortrait ? 'portrait':''}`}>
            <img className={`tour-intro-logo`} src={Logo_Constructora} draggable={false} alt=''/>
            <div className={`tour-intro-space1 ${isPortrait ? 'portrait':''}`}/>
            <img className={`tour-intro-logo`} src={Logo_Proyecto} draggable={false} alt=''/>
          </div>

          <div className={`tour-intro-title ${isPortrait ? 'portrait':''}`}>Te damos la bienvenida al simulador de acabados.</div>

          <div className={`tour-intro-container-tutorial ${isPortrait ? 'portrait':''}`}>
            <div className={`tour-intro-tutorial ${isPortrait ? 'portrait':''}`}>
              <img className={`tour-intro-tutorial-img ${isPortrait ? 'portrait':''}`} src={Icon_Ajustes} draggable={false} alt=''/>
              <div className={`tour-intro-tutorial-text1 ${isPortrait ? 'portrait':''}`}>Personaliza</div>
              <div className={`tour-intro-tutorial-text2 ${isPortrait ? 'portrait':''}`}>Selecciona los muebles y acabados que te gusten.</div>
            </div>
            <div className={`tour-intro-tutorial ${isPortrait ? 'portrait':''}`}>
              <img className={`tour-intro-tutorial-img ${isPortrait ? 'portrait':''}`} src={Icon_Interaccion} draggable={false} alt=''/>
              <div className={`tour-intro-tutorial-text1 ${isPortrait ? 'portrait':''}`}>Interactúa</div>
              <div className={`tour-intro-tutorial-text2 ${isPortrait ? 'portrait':''}`}>Navega en los diferentes espacios del apartamento.</div>
            </div>
            <div className={`tour-intro-tutorial ${isPortrait ? 'portrait':''}`}>
              <img className={`tour-intro-tutorial-img ${isPortrait ? 'portrait':''}`} src={Icon_Cotiza} draggable={false} alt=''/>
              <div className={`tour-intro-tutorial-text1 ${isPortrait ? 'portrait':''}`}>Cotiza</div>
              <div className={`tour-intro-tutorial-text2 ${isPortrait ? 'portrait':''}`}>Recibe información detallada del apartamento de tu interés.</div>
            </div>
          </div>

          <div className={`tour-intro-border ${isPortrait ? 'portrait':''}`}/>

          <div className={`tour-intro-container-tutorial ${isPortrait ? 'portrait':''}`}>
            <div className={`tour-intro-tutorial ${isPortrait ? 'portrait':''}`}>
              <img className={`tour-intro-tutorial-img ${isPortrait ? 'portrait':''}`} src={Icon_Mouse3} draggable={false} alt=''/>
              <div className={`tour-intro-tutorial-text3 ${isPortrait ? 'portrait':''}`}>Haz clic y arrastra para explorar el espacio.</div>
            </div>
            <div className={`tour-intro-tutorial ${isPortrait ? 'portrait':''}`}>
              <img className={`tour-intro-tutorial-img ${isPortrait ? 'portrait':''}`} src={Icon_Mouse2} draggable={false} alt=''/>
              <div className={`tour-intro-tutorial-text3 ${isPortrait ? 'portrait':''}`}>Haz clic en los círculos para explorar el espacio.</div>
            </div>
            <div className={`tour-intro-tutorial ${isPortrait ? 'portrait':''}`}>
              <img className={`tour-intro-tutorial-img ${isPortrait ? 'portrait':''}`} src={Icon_Mouse1} draggable={false} alt=''/>
              <div className={`tour-intro-tutorial-text3 ${isPortrait ? 'portrait':''}`}>Usa el scroll del mouse para ajustar el zoom.</div>
            </div>
          </div>

          <div className={`tour-intro-button ${isPortrait ? 'portrait':''} ${(tourLoaded && productsUpdated) ? '':'disabled'}`} onClick={()=>{if(tourLoaded && productsUpdated){setShowIntro(false)}}}>
            <div className={`tour-intro-button-text ${isPortrait ? 'portrait':''} ${(tourLoaded && productsUpdated) ? '':'disabled'}`}>Ingresar</div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default Intro;
